import React from 'react';

const TagsSection = ({ tags }) => {
  if (!tags || tags.length === 0) return null;

  return (
    <div className="qv-section">
      <h3 className="rolex-section-title">Tags</h3>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '4px' }}>
        {tags.map(tag => {
          const name = tag.name || tag;
          const color = tag.color || '#818181';
          return (
            <span
              key={name}
              style={{
                display: 'inline-block',
                color: '#fff',
                fontSize: 13,
                lineHeight: '21px',
                borderRadius: '14.5px',
                padding: '2px 12px',
                whiteSpace: 'nowrap',
                backgroundColor: color,
              }}
            >
              {name}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default TagsSection;
